export default function (object) {
  const string = [];
  for (const key in object)
    // eslint-disable-next-line no-prototype-builtins
    if (object.hasOwnProperty(key)) {
      string.push(encodeURIComponent(key) + "=" + encodeURIComponent(object[key]));
    }
  return string.join("&");
}
